export default __webpack_public_path__ + "static/media/Inter-MediumItalic.77fc6c7d.woff";